<template>
    <div class="dept-container">
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <el-button type="primary" :icon="Plus" @click="onAddClick()" v-permission="['api:add']">添加</el-button>
                    <el-button :icon="DCaret" @click="handleSort" v-permission="['api:sort']">一键排序</el-button>
                </div>
            </template>
            <el-table :data="table_data" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="接口名称"></el-table-column>
                <el-table-column prop="method" label="接口方法" width="100"></el-table-column>
                <el-table-column prop="path" label="访问路径"></el-table-column>

                <el-table-column prop="group_name" label="接口分组" width="100"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template #default="{ row }">
                        <el-switch
                            style="--el-switch-on-color: #13ce66"
                            v-model="row.status"
                            :active-value="1"
                            :inactive-value="0"
                            @change="(val) => handleStatus(val, row)"
                        />
                    </template>
                </el-table-column>
                <el-table-column prop="list_order" label="排序" width="130">
                    <template #default="scope">
                        <el-input-number
                            style="width: 100px"
                            type="number"
                            v-model="scope.row.list_order"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                            size="small"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="View" circle @click="onShowClick(row)">查看</el-button>
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['api:edit']">
                            编辑
                        </el-button>
                        <el-button type="primary" link :icon="Delete" @click="onRemoveClick(row)" v-permission="['api:remove']">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                background
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>

        <api-forms
            v-model="formDialogVisible"
            :isForm="isForm"
            :formId="selectFormId"
            @updateForm="getApiData"
            :groupList="configGroupList"
        ></api-forms>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import ApiForms from './components/apiForms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { batchDisable, batchEnable, batchSort, delApp, getApiLists } from '@/api/api.js'
import { DCaret, Delete, Edit, Plus, View } from '@element-plus/icons'

// 数据相关
const table_data = ref([])
const total = ref(0)
const page = ref(1)
const size = ref(10)
const configGroupList = ref([])

// 获取数据的方法
const getApiData = async () => {
    const result = await getApiLists({
        page: page.value,
        page_size: size.value
    })
    table_data.value = result.lists
    total.value = result.total
}

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getApiData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getApiData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectFormId = ref('') // 点中的id

// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) selectFormId.value = ''
})
// 查看
const onShowClick = (row) => {
    selectFormId.value = row.id
    isForm.value = false
    formDialogVisible.value = true
}

// 编辑
const onEditClick = (row) => {
    selectFormId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectFormId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// // 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delApp(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getApiData()
        })
        .catch(() => {})
}

// 修改状态
const handleStatus = (val, row) => {
    if (!row.id) return
    const msg = val ? '启用' : '停用'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.name}"接口吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            if (val) {
                await batchEnable([row.id])
            } else {
                await batchDisable([row.id])
            }
            ElMessage({
                type: 'success',
                message: msg + '成功'
            })
        })
        .catch(() => {
            row.status = val ? 0 : 1
        })
}

// 排序
const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getApiData()
}
// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getApiData()
})
</script>

<style lang="scss" scoped>
.el-card {
    overflow-y: auto;
    overflow-x: auto;
}
.pagination {
    float: right;
}
</style>
